import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Head from '../components/Head';
import Foot from '../components/Foot';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const apiUrl = process.env.REACT_APP_API_URL;

function Accreditations() {
  const [accreditations, setAccreditations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  useEffect(() => {
    const fetchAccreditations = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/public/accreditations`);
        if (response.data.success) {
          setAccreditations(response.data.accreditations);
        } else {
          setError(response.data.message || 'Failed to load accreditations.');
        }
      } catch (err) {
        setError('Error fetching accreditations. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchAccreditations();
  }, []);

  const openLightbox = (imageUrl, index) => {
    setPhotoIndex(index);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };

  return (
    <>
      <Head />
      {/* Start Hero */}
      <section className="common-page-hero">
        <img
          src="assets/img/bg/common-bg.png"
          className="common-hero-bg ak-bg"
          alt="..."
        />
        <div className="common-hero-content">
          <div className="common-hero-info">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3" style={{ marginTop: 100 }}>
              <p className="ak-section-subtitle animation-title">Discover</p>
              <h2 className="ak-section-title animation-title">Accreditations</h2>
            </div>
            <p className="back-btn">
              <a href="/">Home</a> / Discover / Accreditations
            </p>
          </div>
          <a href="" className="phone-number">
            +91 90486 48777
          </a>
        </div>
      </section>
      {/* End Hero */}
   
   
   
  {/* Start All Services*/}
  <div className="ak-height-60 ak-height-lg-50" />
  <section>
    <div className="container">
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
        <div className="col">
          <div className="image-card h-100 bg-white shadow-lg rounded-lg overflow-hidden">
            <div
              className="image-thumbnail cursor-pointer"
              onclick="openLightbox('assets/img/accreditation/1.png')"
            >
              <img
                src="assets/img/accreditation/1.png"
                alt="Infrastructure 1"
                className="w-full h-64 object-cover"
              />
              <div className="image-card-btn flex items-center justify-center bg-gray-800 bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300">
                <span className="text-white font-semibold">View Image</span>
              </div>
            </div>
            <div className="p-4">
              <h5 className="text-lg font-semibold">iwfm</h5>
              {/* <p class="text-gray-600">Modern office complex</p> */}
            </div>
          </div>
        </div>
        <div className="col">
          <div className="image-card h-100 bg-white shadow-lg rounded-lg overflow-hidden">
            <div
              className="image-thumbnail cursor-pointer"
              onclick="openLightbox('assets/img/accreditation/2.png')"
            >
              <img
                src="assets/img/accreditation/2.png"
                alt="Infrastructure 1"
                className="w-full h-64 object-cover"
              />
              <div className="image-card-btn flex items-center justify-center bg-gray-800 bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300">
                <span className="text-white font-semibold">View Image</span>
              </div>
            </div>
            <div className="p-4">
              <h5 className="text-lg font-semibold">MEFMA</h5>
              {/* <p class="text-gray-600">Modern office complex</p> */}
            </div>
          </div>
        </div>
        <div className="col">
          <div className="image-card h-100 bg-white shadow-lg rounded-lg overflow-hidden">
            <div
              className="image-thumbnail cursor-pointer"
              onclick="openLightbox('assets/img/accreditation/3.png')"
            >
              <img
                src="assets/img/accreditation/3.png"
                alt="Infrastructure 1"
                className="w-full h-64 object-cover"
              />
              <div className="image-card-btn flex items-center justify-center bg-gray-800 bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300">
                <span className="text-white font-semibold">View Image</span>
              </div>
            </div>
            <div className="p-4">
              <h5 className="text-lg font-semibold">CPD</h5>
              {/* <p class="text-gray-600">Modern office complex</p> */}
            </div>
          </div>
        </div>
        <div className="col">
          <div className="image-card h-100 bg-white shadow-lg rounded-lg overflow-hidden">
            <div
              className="image-thumbnail cursor-pointer"
              onclick="openLightbox('assets/img/accreditation/4.png')"
            >
              <img
                src="assets/img/accreditation/4.png"
                alt="Infrastructure 1"
                className="w-full h-64 object-cover"
              />
              <div className="image-card-btn flex items-center justify-center bg-gray-800 bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300">
                <span className="text-white font-semibold">View Image</span>
              </div>
            </div>
            <div className="p-4">
              <h5 className="text-lg font-semibold">ISO 9001:2015</h5>
              {/* <p class="text-gray-600">Modern office complex</p> */}
            </div>
          </div>
        </div>
        <div className="col">
          <div className="image-card h-100 bg-white shadow-lg rounded-lg overflow-hidden">
            <div
              className="image-thumbnail cursor-pointer"
              onclick="openLightbox('assets/img/accreditation/5.png')"
            >
              <img
                src="assets/img/accreditation/5.png"
                alt="Infrastructure 1"
                className="w-full h-64 object-cover"
              />
              <div className="image-card-btn flex items-center justify-center bg-gray-800 bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-300">
                <span className="text-white font-semibold">View Image</span>
              </div>
            </div>
            <div className="p-4">
              <h5 className="text-lg font-semibold">ISO 21001:2018</h5>
              {/* <p class="text-gray-600">Modern office complex</p> */}
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
  </section>
  {/* End All Services*/}


      <div className="ak-height-20 ak-height-lg-30" />
      <Foot />

      {isLightboxOpen && (
        <Lightbox
          mainSrc={`${apiUrl}/${accreditations[photoIndex].imagepath}`}
          nextSrc={`${apiUrl}/${accreditations[(photoIndex + 1) % accreditations.length].imagepath}`}
          prevSrc={`${apiUrl}/${accreditations[(photoIndex + accreditations.length - 1) % accreditations.length].imagepath}`}
          onCloseRequest={closeLightbox}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + accreditations.length - 1) % accreditations.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % accreditations.length)
          }
          imageTitle={accreditations[photoIndex].title}
          imageCaption="Accreditation Image"
        />
      )}
    </>
  );
}

export default Accreditations;